import React from 'react';
import { Button, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import IPaymentschedule from 'icons/IPaymentschedule';

export type ScheduleButtonProps = Omit<ButtonProps, 'icon'> & {
  comcode: string;
  twoToneColor: string;
  onlyicon?:boolean;
};

const SCHEDULE_LABELS: Record<string, string> = {
  FR: 'Echéancier de paiement',
  EN: 'Payment Schedule',
};

const ScheduleButton = ({
  comcode,
  twoToneColor,
  onlyicon,
  ...otherProps
}: ScheduleButtonProps) => {
  const { label, hint } = useComponentConfiguration(comcode);

  const resolvedLabel =
    !label || label.startsWith('##')
      ? SCHEDULE_LABELS[localStorage.getItem('lancode') ?? 'EN'] ?? 'Payment Schedule'
      : label;

  return (
    <Tooltip title={hint}>
      <Button
        icon={<IPaymentschedule color={twoToneColor?twoToneColor:"blue"} height="17px" width="16px"/>}
        {...otherProps}
      >
        {!onlyicon ? resolvedLabel : null}
      </Button>
    </Tooltip>
  );
};

export default ScheduleButton;
